import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href", "target", "data-app-event", "data-app-argument"]

import { computed } from "vue";
import { isMobileApp, triggerMobileAppEvent } from "../mobile-app-integration";
import type { MobileAppMethodName } from "../mobile-app-models";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import type { SvgIcons } from "@sazka/design-system/src/icon/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'mobile-app-link',
  props: {
    href: {},
    target: {},
    eventName: {},
    eventArgument: {},
    iconLeft: {},
    iconRight: {},
    openInNewTab: { type: Boolean },
    isExternal: { type: Boolean }
  },
  emits: ["linkClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const attributes = computed(() => {
    const attributes: Record<string, string | null> = {
        target: null,
        rel: null,
    };

    if (props.openInNewTab || props.isExternal) {
        attributes.target = "_blank";
        attributes.rel = "noopener";
    }
    if (props.isExternal) {
        attributes.rel += " noreferrer";
    }

    return attributes;
});

const handleClick = (event: Event) => {
    emit("linkClicked");

    if (props.eventName && isMobileApp) {
        event.preventDefault();
        triggerMobileAppEvent(props.eventName as string, props.eventArgument);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", _mergeProps({
    onClick: handleClick,
    href: _ctx.href,
    target: _ctx.target,
    "data-app-event": _ctx.eventName,
    "data-app-argument": _ctx.eventArgument
  }, attributes.value), [
    (_ctx.iconLeft)
      ? (_openBlock(), _createBlock(DsIcon, {
          key: 0,
          width: 16,
          height: 16,
          name: _ctx.iconLeft
        }, null, 8, ["name"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.iconRight)
      ? (_openBlock(), _createBlock(DsIcon, {
          key: 1,
          width: 16,
          height: 16,
          name: _ctx.iconRight
        }, null, 8, ["name"]))
      : _createCommentVNode("", true)
  ], 16, _hoisted_1))
}
}

})